import React, { ElementType, FC, HTMLAttributes } from 'react';
import styles from './style.module.css';

type ResponsiveOffset = {
  base?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
};

interface ColProps extends HTMLAttributes<HTMLDivElement> {
  as?: ElementType;
  base?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  offset?: ResponsiveOffset;
  truncate?: boolean;
}

export const Col: FC<ColProps> = ({
  children,
  as: Tag = 'div',
  base,
  sm,
  md,
  lg,
  xl,
  offset,
  truncate,
  className,
  style,
  ...rest
}) => {
  const classes = [
    styles.col,
    base && styles[`col-${base}`],
    sm && styles[`col-sm-${sm}`],
    md && styles[`col-md-${md}`],
    lg && styles[`col-lg-${lg}`],
    xl && styles[`col-xl-${xl}`],
    offset?.base && styles[`offset-${offset.base}`],
    offset?.sm && styles[`offset-sm-${offset.sm}`],
    offset?.md && styles[`offset-md-${offset.md}`],
    offset?.lg && styles[`offset-lg-${offset.lg}`],
    offset?.xl && styles[`offset-xl-${offset.xl}`],
    truncate && styles.truncate,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag className={classes} style={{ ...style }} {...rest}>
      {children}
    </Tag>
  );
};
